/**
 * Responsible in creating Evis group names and their respective evisIDNames. 
 * The function sorts the group names alphabetically and the evisIDNames within the group.
 * @param {Array} evisData array of objects with evisIDName and groupName properties
 * @returns {Array} array of objects with groupName and evisIDNames(array) properties
 */
export const organizeEvisDataByGroup = (evisData) => {
    if (!evisData) return {};

    const evisGroupsDetails = {};

    for (const { evisIDName, groupName, status } of evisData) {
        if (!evisGroupsDetails[groupName]) {
            evisGroupsDetails[groupName] = [];
        }
        evisGroupsDetails[groupName].push({ evisId: evisIDName, status: status });
    }

    return [Object.fromEntries(
        Object.keys(evisGroupsDetails)
            .sort((a, b) => a.localeCompare(b))
            .map((groupName) => [
                groupName,
                evisGroupsDetails[groupName].sort((a, b) => a.evisId.localeCompare(b.evisId))
            ])
    )];
};
/**
 * Sorts stream based on priority; Failover group, partner ingress, backfaul stream
 * @param {*} listOfStreamObjects stream objects
 * @param {*} evisId evisId
 * @returns sorted stream objects or empty array if listOfStreamObjects is not an array or empty
 */
const sortEvisStreamsByPriority = (listOfStreamObjects, evisId) => {
    if (!listOfStreamObjects || !Array.isArray(listOfStreamObjects) || listOfStreamObjects.length === 0) {
        return [];
    }

    // Extract suffix after evisId: -<region>-<prim|secd|grp>-<unique_id>
    const getSuffix = (streamId) => {
        const idx = streamId.toLowerCase().indexOf(evisId.toLowerCase());
        if (idx === -1) return streamId;
        return streamId.substring(idx + evisId.length);
    };

    const getStreamCategory = (suffix) => {
        if (suffix.includes('-prim-')) return 0;
        if (suffix.includes('-secd-')) return 1;
        return 2; // grp / failover / unknown
    };

    listOfStreamObjects.sort((a, b) => {
        const suffA = getSuffix(a.stream_id);
        const suffB = getSuffix(b.stream_id);
        const catA = getStreamCategory(suffA);
        const catB = getStreamCategory(suffB);

        // failovers (grp) always last
        if (catA === 2 && catB !== 2) return 1;
        if (catA !== 2 && catB === 2) return -1;
        if (catA === 2 && catB === 2) return suffA.localeCompare(suffB, undefined, { sensitivity: 'base' });

        // type-first sort by input type
        const typeDiffA = a.type === 'partner_ingress' ? 0 : 1;
        const typeDiffB = b.type === 'partner_ingress' ? 0 : 1;
        if (typeDiffA !== typeDiffB) return typeDiffA - typeDiffB;

        // grouped: all prim alphabetically by region, then all secd alphabetically by region
        if (catA !== catB) return catA - catB;
        return suffA.localeCompare(suffB, undefined, { sensitivity: 'base' });
    });

    listOfStreamObjects.forEach((streamObj) => {
        streamObj.evisId = evisId;
    });

    return listOfStreamObjects;
};

export const getInputType = (data) => {

    if (data !== undefined && data["evis.input_type"] !== undefined) {
        return data["evis.input_type"];
    } else {
        return "N/A";
    }


}

export const getBitrate = (data) => {

    if (data !== undefined && data["net_recv.bitrate"] !== undefined) {
        return data["net_recv.bitrate"];
    } else {
        return "N/A";
    }
}

// TODO:

function getEvisSnapshotParams(selectedEvisIdsCheckboxData, evisAttributeState, evisSortMode) {
    const evisIds = [];
    const evisAttributes = [];

    for (const evisId of selectedEvisIdsCheckboxData) {
        evisIds.push(evisId.evisIdName);
    }

    for (const [key, value] of Object.entries(evisAttributeState)) {
        if (value) {
            evisAttributes.push(key);
        }
    }

    return {
        evisIds: evisIds.toString(),
        evisAttributes: evisAttributes.toString(),
        evisSortMode: evisSortMode || "type",
    };
}

export {
    sortEvisStreamsByPriority, getEvisSnapshotParams
};
